import { format } from "date-fns";
import { useContext } from "react";
import { AppContext } from "../contextProviders/AppContext";

export function FormattedDate({ date }) {
  const { locale } = useContext(AppContext);

  //Ke 12.12.2020
  const str = format(date, "eeeeee dd.MM.yyyy", {
    locale: locale,
  });
  return str[0].toUpperCase() + str.slice(1);
}

export function FormattedTime({ date }) {
  const { locale } = useContext(AppContext);

  //Klo. 16.30
  return (
    <>
      {format(date, "HH:mm", {
        locale: locale,
      })}
    </>
  );
}
